import * as Yup from 'yup';


const StaffBudgetValidationSchema =  Yup.object().shape({
    budgetDate : Yup.string().required('Required'),
});
 
export { StaffBudgetValidationSchema } ;